import React, { FC } from 'react';
import cls from 'classnames';

import { ButtonLayoutProps } from './ButtonLayout.types';

const variantMap = {
	buttonStandard: 'buttonLayout-buttonStandard',
	stackVertical: 'buttonLayout-stackVertical',
	stackHorizontal: 'buttonLayout-stackHorizontal',
};

const ButtonLayout: FC<ButtonLayoutProps> = (props) => {
	const { variant, children, className } = props;
	const variantClassName = variantMap[variant];

	return <div className={cls(variantClassName, className)}>{children}</div>;
};

ButtonLayout.displayName = 'ButtonLayout';

export default ButtonLayout;
